import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';

function AdminProfessionalsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isIndex =
    pathname === '/admin/professionals' || pathname === '/admin/professionals/';
  const tab = (suffix: string) => {
    const active =
      (suffix === '' && isIndex) ||
      (suffix !== '' && pathname === `/admin/professionals/${suffix}`);
    return `px-3 py-2 text-sm border-b-2 -mb-px ${
      active
        ? 'border-primary text-primary'
        : 'border-transparent text-gray-500 hover:text-gray-700'
    }`;
  };

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl font-semibold text-gray-900'>Professionals</h1>
        <p className='text-sm text-gray-500 mt-1'>
          Directory listings, trial codes, invite reminders, and coach engagement
          drips.
        </p>
      </div>
      <nav className='flex flex-wrap gap-2 border-b border-gray-200 pb-px'>
        <Link to='/admin/professionals' className={tab('')}>
          Directory
        </Link>
        <Link to='/admin/professionals/codes' className={tab('codes')}>
          Codes
        </Link>
        <Link to='/admin/professionals/invites' className={tab('invites')}>
          Invite reminders
        </Link>
        <Link to='/admin/professionals/engagement' className={tab('engagement')}>
          Engagement
        </Link>
      </nav>
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/admin/professionals')({
  component: AdminProfessionalsLayout,
});
